<div>
    <h1 hidden> {{this.Model.ModelDescription||Model.Caption}}</h1>
    <!-- <div class="bottomspacing">
        <img class="w-100" *ngIf="this.VehicleSeries?.BannerFileURL" src="{{imgadd(this.VehicleSeries.BannerFileURL)}}"/>
    </div> -->
    <div class="keyfeaturemain">
        <div *ngFor="let keyfeature of this.vehicleSeriesKeyFeatures; index as keyfeatureindex;">
            <div *ngIf="
            !((keyfeature.VehicleSpecCategory?.toLowerCase())?.includes('feature')) &&
            !((keyfeature.VehicleSpecCategory?.toLowerCase())?.includes('imageviewer')) &&
            !((keyfeature.VehicleSpecCategory?.toLowerCase())?.includes('buttons')) &&
            !((keyfeature.VehicleSpecCategory?.toLowerCase())?.includes('listing')) &&
            !((keyfeature.VehicleSpecCategory?.toLowerCase())?.includes('tabs'))
            " [innerHtml]="keyfeature.HTMLValue">
            </div>
            <div class="col-12 parentdiv col-md-12 bottomspacing" *ngIf="this.InteriorImages?.length > 0 && this.ExteriorImages?.length > 0 && (keyfeature.VehicleSpecCategory?.toLowerCase())?.includes('imageviewer')">
                <div class="col-12 col-sm-6 half-width text-center ImageCarousel">
                    <h3><b>INTERIOR VIEW</b></h3>
                    <app-slider [autoScroll]="false" [carouselStyling]="'sideBySide'"  [id]="'interior'+(this.Model?.VehicleModelID_PK)" [images]="this.InteriorImages"
                    *ngIf="this.Images!==null"></app-slider>
                </div>
                <div class="col-12 col-sm-6 half-width text-center ImageCarousel">
                    <h3><b>EXTERIOR VIEW</b></h3>
                    <app-slider [autoScroll]="false" [carouselStyling]="'sideBySide'" [id]="'exterior'+(this.Model?.VehicleModelID_PK)" [images]="this.ExteriorImages"
                    *ngIf="this.Images!==null"></app-slider>
                </div>
            </div>
            <app-dynamicslider *ngIf="(keyfeature.VehicleSpecCategory?.toLowerCase())?.includes('featureshow')" [features]="vehicleFeatures"></app-dynamicslider> 
            <div class="overlay-buttons" *ngIf="(keyfeature.VehicleSpecCategory?.toLowerCase())?.includes('tabsshow')">
                <div class="padding-title text-wrap">
                    <h2><strong>STANDARD SPECIFICATIONS</strong></h2>
                </div>
                <div class="row col-12 col-md-12 content-block">
                    <div class="tab-headings">
                        <button class="content-heading" *ngFor="let heading of this.tabsHeadings; index as i" [ngClass]="{'active': currentIndex == i}" (click)="currentHeading(i)">
                            <span [innerHTML]="heading.HTMLValue"></span>
                        </button>
                    </div>
                    <div class="tab-content">
                        <span [innerHTML]="tabsList[currentIndex].HTMLValue"></span>    
                    </div>
                </div>
            </div>
        </div>
        <div class="text-center footerbuttongroup">
            <button class="btn-primary marginTopButtons" (click)="enquire()">Enquiry</button>
            <button class="btn-primary" *ngIf="this.Model.Brochure" (click)="openBrochure(this.Model.Brochure)">Brochure</button>
            <button class="btn-primary" *ngIf="this.Model.Accessories" (click)="openBrochure(this.Model.Accessories)">Spec Sheet</button>
            <button class="btn-primary" (click)="back()">View All Series</button>
        </div>
        <div>
            <img (click)="enquire()" class="w-100" *ngIf="this.VehicleSeries?.SecondaryImageUrl" src="{{imgadd(this.VehicleSeries.SecondaryImageUrl)}}"/>
        </div>
    </div>
</div>